import { Flex } from 'antd'
import React, { memo } from 'react'

import s from './loading.module.css'

export default memo(function Loading() {
  return (
    <Flex
      align="center"
      justify="center"
      className={s.Loading}
    >
      <video
        loop
        muted
        autoPlay
        playsInline
        className={s.LoadingVideo}
      >
        <source src="/assets/loading.mp4" type="video/mp4" />
      </video>
    </Flex>
  )
})
